import { ChevronDown } from "lucide-react";

const ScrollIndicator = () => {
  const handleClick = () => {
    const next = document.getElementById("product");
    if (next) {
      next.scrollIntoView({ behavior: "smooth" });
    } else {
      window.scrollBy({ top: window.innerHeight * 0.8, behavior: "smooth" });
    }
  };

  return (
    <button
      onClick={handleClick}
      aria-label="Scroll down"
      className="group w-9 h-9 rounded-full border border-border/40 bg-card/60 backdrop-blur-sm flex items-center justify-center transition-all duration-300 hover:border-accent/50 hover:neon-glow-accent cursor-pointer"
    >
      <ChevronDown
        size={15}
        className="text-muted-foreground group-hover:text-accent transition-colors duration-300"
        style={{ animation: "breathe 1.5s infinite" }}
      />
    </button>
  );
};

export default ScrollIndicator;
